/**
 * +specs: bot kits per specialisation, one file per base class (the class agents add theirs here;
 * docs/design/classes/specs.md "Checklist"). kitFor() picks the spec kit whenever the unit's
 * ClassDef carries `specId`.
 */
import type { ClassKit } from '../kits';
import { WARRIOR_SPEC_KITS } from './warrior';
import { ROGUE_SPEC_KITS } from './rogue'; // +rogue-specs
import { MAGE_SPEC_KITS } from './mage'; // +mage-specs
import { ACOLYTE_SPEC_KITS } from './acolyte'; // +acolyte-specs
import { RANGER_SPEC_KITS } from './ranger'; // +ranger-specs

export const SPEC_KITS: Readonly<Record<string, ClassKit>> = {
  ...WARRIOR_SPEC_KITS,
  ...ROGUE_SPEC_KITS,
  ...MAGE_SPEC_KITS,
  ...ACOLYTE_SPEC_KITS, // +acolyte-specs
  ...RANGER_SPEC_KITS, // +ranger-specs
};
